import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW0E00InputModel } from '../../../commons/kymw0e/kymw0e00/vo/kymw0e00-input.model';
import { KYMW0B00InputModel } from '../../../commons/kymw0b/kymw0b00/vo/kymw0b00-input.model';
import { KYMW0B00OutputModel } from '../../../commons/kymw0b/kymw0b00/vo/kymw0b00-output.model';
import { KYMW1600InputModel } from './vo/kymw1600-input.model';
import { KYMW1600Component } from './kymw1600.component';
import { GetImageInfoModel } from './vo/get-image-info.model';
import { GetUseImageInfoModel } from './vo/get-use-image-info.model';
import { UpdateImageInfoModel } from './vo/update-image-info.model';
import { GetImageFileUrlModel } from './vo/get-image-file-url.model';
import { ImageInfoDetailBoxComponent } from './image-info-detail-box/image-info-detail-box.component';
import { Injectable } from "@angular/core";

/**
 * 画像確認画面の値を管理するクラス
 *
 * @export KYMW1600Model
 * @class KYMW1600Model
 */
@Injectable()
export class KYMW1600Model {

  public kymw1600Component: KYMW1600Component;

  public imageInfoList: any;

  /** 使用画像情報保持 */
  public useImageInfoList: any;

  /** 使用画像選択で使用する検索条件保持 */
  public imageInfoVO: GetImageInfoModel;

  /** 選択中の画像 */
  public goodsImage: string;

  // ボタン活性・非活性
  public selectedImageExistFlg = Boolean(false);	// 選択画像存在フラグ

  /* 選択イメージID */
  public selectedImageId: string;
  public selectedImageName: string;
  public selectedImageFileName: string;
  public tempSelectedImageId: string;

  /* サーバ一時PNGファイル名 */
  public tempPNGFileName: string;
  /* サーバ一時EPSファイル名 */
  public tempEPSFileName: string;
  // サーバ一時JPG(S)ファイル名
  public tempJPGSFileName: string;
  // サーバ一時JPG(M)ファイル名
  public tempJPGMFileName: string;
  // サーバ一時JPG(L)ファイル名
  public tempJPGLFileName: string;

  /* 画像詳細情報変更フラグ */
  public imageInfoDetailChangeFlg: boolean;

  // 履歴情報
  public startOrderCodeBefore: string;
  public endOrderCodeBefore: string;

  /** 画像検索結果最大表示数 */
  public readonly IMAGE_LIST_COUNT: number = <number>1000;

  /** 画像種別 */
  public imageType: string = <string>'';

  /** 権限「1」は閲覧モード「２」フルコントロール */
  public funcPermission: string = <string>'2';

  /**
   * 画像情報更新
   *
   * @param goodsImageList: any
   */
  public updateImageInfoList(goodsImages: any): void {
    if (goodsImages == null || PlessViewUtilsSub.isEmptyArray(goodsImages)) {
      this.kymw1600Component.dialogService.openAlertGetMessage('E0100');
      return;
    }

    let imageListCnt: number = <number>0;

    let searchImage1000List: Array<any> = Array<any>();
    if (goodsImages.length > this.IMAGE_LIST_COUNT) {
      this.kymw1600Component.dialogService.openAlertGetMessage('I0102', ['1000', '1000']);
      // 表示最大値に加工して表示
      let cnt: number = <number>0;
      for (let i = Number(0); i < this.IMAGE_LIST_COUNT; i++) {
        searchImage1000List.push(goodsImages[i]);
        cnt++;
      }
      imageListCnt = cnt;
    } else {
      searchImage1000List = goodsImages;
      imageListCnt = goodsImages.length;
    }

    this.imageInfoList = searchImage1000List;
    for(const imageInfo of this.imageInfoList) {
      imageInfo.Selected = PlessViewUtilsSub.StringBooleanTOBoolean(imageInfo.Selected);
    }
    this.selectedImageId = '';
    this.imageInfoDetailChangeFlg = false;
    this.viewHeler.vw_ImageInfoList.imageInfoListCnt = imageListCnt.toString();
    this.viewHeler.vw_ImageInfoList.imageInfoListOrderCode = '';
    this.goodsImage = '';
    this.imageInfoDetailBox.clear();
    this.imageInfoDetailBox.componentEnabled = false;
    this.selectedImageName = '';
    this.selectedImageFileName = '';
    this.startOrderCodeBefore = '';
    this.endOrderCodeBefore = '';
    this.imageListButtonEnable(true);
    this.imageDetailButtonEnable(false);
  }

  /**
   * ボタン活性・非活性化処理を行う
   */
  private imageListButtonEnable(flg: boolean): void {
    // 受注コード活性
    this.viewHeler.vw_ImageInfoList.imageInfoListOrderCodeEnabled = flg;
    // 使用画像選択ボタン非活性
    this.viewHeler.vw_ImageInfoList.btnAllSelectEnabled = flg;
    this.viewHeler.vw_ImageInfoList.btnAllUnSelectEnabled = flg;
    this.viewHeler.vw_ImageInfoList.btnImageOutputEnabled = flg;
  }

  /**
   * ボタン活性・非活性化処理を行う
   */
  private imageDetailButtonEnable(flg: boolean): void {
    this.kymw1600Component.vw_ImageInfoDetail.btnSettingEnabled = flg;
    this.kymw1600Component.vw_ImageInfoDetail.btnUseStopEnabled = flg;
    this.kymw1600Component.vw_ImageInfoDetail.btnUseUnStopEnabled = flg;
    this.kymw1600Component.vw_ImageInfoDetail.btnResetEnabled = flg;
    this.kymw1600Component.vw_ImageInfoDetail.btnDeleteEnabled = flg;
  }

  /**
   * 使用画像出力更新
   * @param useImageInfoList: any
   */
  public updateUseImageInfoList(data: any): void {

    // 表示最大値情報退避エリア
    const useImage1000List: Array<any> = [];

    // 使用画像情報の検索結果判定
    // 検索結果がない場合に改行コードと空白が返されるため、
    // 改行コードの置換とtrimを実施して検索結果がないことを判定
    if (PlessViewUtilsSub.isEmptyArray(data)) {
    // 項番2231 END 障害管理No.U01247対応
      // 検索結果がない場合、エラー表示
      this.kymw1600Component.dialogService.openAlertGetMessage('E0100');
      return;
    }

    // 表示最大値より使用画像情報が大きい場合、メッセージを表示する
    if (data.length > this.IMAGE_LIST_COUNT) {
      // 表示最大値まで表示すための情報取得
      for (let i = Number(0); i <= this.IMAGE_LIST_COUNT; i++) {
        useImage1000List.push(data[i]);
      }

      // 使用画像情報保持エリアに、表示最大値情報退避エリアの情報を設定
      this.useImageInfoList = useImage1000List;
    } else {
      // 使用画像情報保持エリアに、引数の情報を設定
      this.useImageInfoList = data;
    }

    // 画像情報がある場合、チェック処理を実施する
    if (this.imageInfoList !== null) {
      // 画像情報の検索結果が複数件あるかチェック
      if (this.imageInfoList instanceof Array) {
        // 画像情報の検索結果が複数件の場合の処理
        // 画像出力チェックボックスを初期化する
        for (let i = Number(0); i < this.imageInfoList.length; i++) {
          this.imageInfoList[i].Selected = false;
        }

        // 使用画像情報の検索結果が複数件あるかチェック
        if (this.useImageInfoList instanceof Array) {
          // 画像情報と使用画像情報の検索結果が複数件ある場合
          // 受注コードを使用している画像出力チェックボックスをチェックする
          for (let j = Number(0); j < this.useImageInfoList.length; j++) {
            for (let k = Number(0); k < this.imageInfoList.length; k++) {
              // 使用画像情報の画像ID = 画像情報の画像IDの場合、画像出力チェックボックスをチェックする
              if (this.useImageInfoList[j].ImageId === this.imageInfoList[k].ImageId) {
                this.imageInfoList[k].Selected = true;
              }
            }
          }
          // 使用画像有無判定
          if (!this.isImageSelected()) {
            // 画像出力チェックボックスがONでない場合、使用画像無しとして、エラー表示
            this.kymw1600Component.dialogService.openAlertGetMessage('E0100');
            return;
          }
        } else {
          // 使用画像情報の検索結果が１件で画像情報の検索結果が複数件ある場合
          //// 受注コードを使用している画像出力チェックボックスをチェックする
          for (let l = Number(0); l < this.imageInfoList.length; l++) {
            // 使用画像情報の画像ID = 画像情報の画像IDの場合、画像出力チェックボックスをチェックする
            if (this.useImageInfoList.ImageId === this.imageInfoList[l].ImageId) {
              this.imageInfoList[l].Selected = true;
            }
          }
          // 使用画像有無判定
          if (!this.isImageSelected()) {
            // 画像出力チェックボックスがONでない場合、使用画像無しとして、エラー表示
            this.kymw1600Component.dialogService.openAlertGetMessage('E0100');
            return;
          }
        }
      } else {
        // 画像情報の検索結果が1件の場合の処理
        // 画像出力チェックボックスを初期化する
        this.imageInfoList.Selected = false;

        // 画像情報の検索結果が1件の場合、使用画像情報の検索結果は複数件はありえない(1件のみ)
        //// 使用画像情報の画像ID = 画像情報の画像IDの場合、画像出力チェックボックスをチェックする
        if (this.useImageInfoList.ImageId === this.imageInfoList.ImageId) {
          this.imageInfoList.Selected = true;
        }
      }
    }
  }

  /**
   * 詳細部停止フラグによるボタン制御
   *
   */
  private detailButtonEnable(enabled: string): void {
    if (enabled === '0') {
      this.kymw1600Component.vw_ImageInfoDetail.btnUseStopEnabled = true;
      this.kymw1600Component.vw_ImageInfoDetail.btnUseUnStopEnabled = false;
      this.kymw1600Component.vw_ImageInfoDetail.btnDeleteEnabled = false;
    } else {
      this.kymw1600Component.vw_ImageInfoDetail.btnUseStopEnabled = false;
      this.kymw1600Component.vw_ImageInfoDetail.btnUseUnStopEnabled = true;
      this.kymw1600Component.vw_ImageInfoDetail.btnDeleteEnabled = true;
    }
  }

  /**
   * 画像詳細情報更新
   *
   * @param data: any
   */
  public updateImageInfoDetail(data: any): void {
    this.imageInfoDetailBox.clear();

    let endOrderCode2: number = <number>0;
    if (data.EndOrderCode === '9999999') {
      endOrderCode2 = 1;
      data.EndOrderCode = '';
    } else if (String(data.StartOrderCode) === String(data.EndOrderCode)) {
      endOrderCode2 = 2;
    }

    this.goodsImage = data.ImagePath;
    this.imageInfoDetailBox.txi_StartOrderCode.setOrderCode(data.StartOrderCode);
    this.imageInfoDetailBox.startOrderCode = data.StartOrderCode;
    this.imageInfoDetailBox.txi_EndOrderCode1.setOrderCode(data.EndOrderCode);
    this.imageInfoDetailBox.endOrderCode = data.EndOrderCode;
    this.imageInfoDetailBox.endOrderCode2 = endOrderCode2.toString();
    this.imageInfoDetailBox.imageName = data.ImageName;
    this.imageInfoDetailBox.imageFileName = data.ImageFileName;
    this.imageInfoDetailBox.imageBelongName = this.getCodeValueName(data.ImageBelongId, data.ImageBelongName);
    this.imageInfoDetailBox.imageKindName = this.getCodeValueName(data.ImageKind, data.ImageKindName);
    this.imageInfoDetailBox.imageTypeName = this.getCodeValueName(data.ImageType, data.ImageTypeName);
    this.imageInfoDetailBox.cmb_ProcessInstruct.setCodeValue(data.ProcessInstruct);
    this.imageInfoDetailBox.processInstruct = data.ProcessInstruct;
    this.imageInfoDetailBox.remarks = data.Remarks;
    this.imageInfoDetailBox.cookingExPublish = PlessViewUtilsSub.StringTOBoolean(data.CookingExPublish);
    this.imageInfoDetailBox.priority = data.Priority;
    this.imageInfoDetailBox.pcode = data.Pcode;
    this.imageInfoDetailBox.guideGoodsName = data.GuideGoodsName;
    this.imageInfoDetailBox.guideStandardName = data.GuideStandardName;
    this.imageInfoDetailBox.cmb_CookingDiv.setCodeValue(data.CookingDiv);
    this.imageInfoDetailBox.cookingName = data.CookingName;
    this.imageInfoDetailBox.materialName = data.MaterialName;
    this.imageInfoDetailBox.keyWord = data.KeyWord;
    this.imageInfoDetailBox.cmb_EventId.setCodeValue(data.EventId);
    this.imageInfoDetailBox.cmb_PhotoContentsDiv.setCodeValue(data.PhotoContentsDiv);
    this.imageInfoDetailBox.photoInstructContents = data.PhotoInstructContents;
    this.imageInfoDetailBox.photoStudioId = data.PhotoStudioId;
    this.imageInfoDetailBox.photoSchedule = PlessViewUtilsSub.editDate(data.PhotoSchedule, '2');

    this.imageInfoDetailBox.cmb_PhotoStudioId.setStudioId(data.PhotoStudioId);
    this.imageInfoDetailBox.imageInstructDate = data.ImageInstructDate;
    this.imageInfoDetailBox.fileRegistDate = data.FileRegistDate;
    this.imageInfoDetailBox.captiontext = data.TextCaption;


    this.startOrderCodeBefore = data.StartOrderCode;
    this.endOrderCodeBefore = data.EndOrderCode;
    this.selectedImageName = data.ImageName;
    this.selectedImageFileName = data.ImageFileName;

    this.imageType = data.ImageType;

    // 閲覧モード
    if (this.funcPermission === '1') {
      this.imageDetailButtonEnable(false);
      this.imageInfoDetailBox.componentEnabled = false;
    } else {
      this.imageDetailButtonEnable(true);
      this.detailButtonEnable(data.Enabled);
      this.imageInfoDetailBox.componentEnabled = true;

      this.kymw1600Component.bindStartOrderCodeTextInputSelectedOrderCode(this.imageInfoDetailBox.txi_StartOrderCode.selectedOrderCode);
      this.kymw1600Component.bindEndOrderCodeComboBox(this.imageInfoDetailBox.endOrderCode2);

      // 画像種別が「C:調理イメージ」の場合、「調理指示」を活性にする。
      if (PlessViewUtilsSub.nullToBlank(this.imageType) === 'C') {
        this.imageInfoDetailBox.cmbProcessInstructDisabled = false;
      } else {
        this.imageInfoDetailBox.cmbProcessInstructDisabled = true;
      }
    }
  }

  /**
   * 全選択、全解除処理を行う
   *
   * @param selectFlg: boolean
   */
  public updateAllSelect(selectFlg: boolean): void {
    if (this.imageInfoList != null) {
      if (this.imageInfoList instanceof Array) {
        for (let i = Number(0); i < this.imageInfoList.length; i++) {
          this.imageInfoList[i].Selected = selectFlg;
        }
      } else {
        this.imageInfoList.Selected = selectFlg;
      }
    }
  }

  /**
   * 画像選択有無チェックを行う
   *
   * @return Boolean:TRUE:選択有、FALSE:選択無
   */
  public isImageSelected(): boolean {
    if (this.imageInfoList != null) {
      if (this.imageInfoList instanceof Array) {
        for (let i = Number(0); i < this.imageInfoList.length; i++) {
          if (this.imageInfoList[i].Selected) {
            return true;
          }
        }
      } else {
        if (this.imageInfoList.Selected) {
          return true;
        }
      }
    }
    return false;
  }

  /*----------------------------------------------------------------------
  VO Getter
  ---------------------------------------*/
  /**
   * KYMW0B00InputVOを返却する
   *
   * @return KYMW0B00InputVO
   */
  public getKYMW0B00InputVO(): KYMW0B00InputModel {
    const vo: KYMW0B00InputModel = new KYMW0B00InputModel();
    vo.processDiv = '2';
    // C2PF検索項目表示フラグ
    vo.c2pfSearchVisibleFlg = '0';
    return vo;
  }

  /**
   * GetImageFileUrlVOを返却する
   *
   * @return GetImageFileUrlVO
   */
  public getGetImageFileUrlVO(extension: string): GetImageFileUrlModel {
    const vo: GetImageFileUrlModel = new GetImageFileUrlModel();
    vo.extension = extension;
    vo.imageIdList = '';

    if (this.imageInfoList != null) {
      if (this.imageInfoList instanceof Array) {
        for (let i = Number(0); i < this.imageInfoList.length; i++) {
          if (this.imageInfoList[i].Selected) {
            vo.imageIdList += String(this.imageInfoList[i].ImageId) + ',';
          }
        }
      } else {
        vo.imageIdList = this.imageInfoList.ImageId;
      }
    }
    return vo;
  }

  /**
   * UpdateImageInfoVOを返却する
   *
   * @return UpdateImageInfoVO
   */
  public getUpdateImageInfoVO(): UpdateImageInfoModel {
    const vo: UpdateImageInfoModel = new UpdateImageInfoModel();
    vo.imageId = this.selectedImageId;
    vo.startOrderCode = this.imageInfoDetailBox.txi_StartOrderCode.selectedOrderCode;
    if (this.imageInfoDetailBox.endOrderCode2 === '1') {
      vo.endOrderCode = '9999999';
    } else {
      vo.endOrderCode = this.imageInfoDetailBox.txi_EndOrderCode1.selectedOrderCode;
    }
    vo.processInstruct = this.imageInfoDetailBox.cmb_ProcessInstruct.selectedCodeValue;
    vo.remarks = this.imageInfoDetailBox.remarks;
    vo.cookingExPublish = PlessViewUtilsSub.booleanTOString(this.imageInfoDetailBox.cookingExPublish);
    vo.priority = this.imageInfoDetailBox.priority;
    vo.cookingDiv = this.imageInfoDetailBox.cmb_CookingDiv.selectedCodeValue;
    vo.cookingName = this.imageInfoDetailBox.cookingName;
    vo.materialName = this.imageInfoDetailBox.materialName;
    vo.keyWord = this.imageInfoDetailBox.keyWord;
    vo.eventId = this.imageInfoDetailBox.cmb_EventId.selectedCodeValue;
    vo.photoContentsDiv = this.imageInfoDetailBox.cmb_PhotoContentsDiv.selectedCodeValue;
    vo.photoInstructContents = this.imageInfoDetailBox.photoInstructContents;
    vo.photoSchedule = PlessViewUtilsSub.editDate(this.imageInfoDetailBox.dfd_PhotoSchedule.text, '1');
    vo.photoStudioId = this.imageInfoDetailBox.cmb_PhotoStudioId.selectedStudioId;
    vo.textCaption = this.imageInfoDetailBox.captiontext;
    return vo;
  }

  /**
   * UpdateEnabledDelete用のVOを返却する
   *
   * @return UpdateEnabledDeleteVO
   */
  public getUpdateEnabledDeleteVO(procMode: string): any {
    const vo = {
      procMode: procMode,
      imageId: this.selectedImageId,
    };
    return vo;
  }

  /**
   * ReplaceImageFileUpload用のVOを返却する
   *
   * @return ReplaceImageFileUploadVO
   */
  public getReplaceImageFileUploadVO(fileRef: File): any {
    const vo = {
      fileRef: fileRef,
    };
    return vo;
  }

  /**
   * ReplaceImageFileVOを返却する
   *
   * @return ReplaceImageFileVO
   */
  public getReplaceImageFileVO(): any {
    const vo = {
      imageId: this.selectedImageId,
      tempEPSFileName: this.tempEPSFileName,
      tempPNGFileName: this.tempPNGFileName,
      tempJPGSFileName: this.tempJPGSFileName,
      tempJPGMFileName: this.tempJPGMFileName,
      tempJPGLFileName: this.tempJPGLFileName,
    };
    return vo;
  }

  /**
   * GetImageInfoVOを返却する
   *
   * @return GetImageInfoVO
   */
  public getGetImageInfoVO(outputVO: KYMW0B00OutputModel): GetImageInfoModel {
    const vo: GetImageInfoModel = new GetImageInfoModel();
    // Pコード
    vo.pcodeList = PlessViewUtilsSub.nullToBlank(outputVO.pcodeList);
    // 商品案内用商品名
    vo.guideGoodsName = PlessViewUtilsSub.nullToBlank(outputVO.guideGoodsName);
    // 商品案内用規格名
    vo.guideStandardName = PlessViewUtilsSub.nullToBlank(outputVO.guideStandardName);
    // 画像名
    vo.imageName = PlessViewUtilsSub.nullToBlank(outputVO.imageName);
    // 画像ファイル名
    vo.imageFileName = PlessViewUtilsSub.nullToBlank(outputVO.imageFileName);
    // 画像所属
    vo.imageBelongId = PlessViewUtilsSub.nullToBlank(outputVO.imageBelongID);
    // 画像種類
    vo.imageKind = PlessViewUtilsSub.nullToBlank(outputVO.imageKind);
    // 画像種別
    vo.imageType = PlessViewUtilsSub.nullToBlank(outputVO.imageType);
    // 調理指示
    vo.processInstruct = PlessViewUtilsSub.nullToBlank(outputVO.processInstruct);
    // 備考
    vo.remarksList = PlessViewUtilsSub.nullToBlank(outputVO.remarks);
    // 調理例掲載区分
    // 調理例掲載区分が掲載の場合
    vo.cookingExPublish = (PlessViewUtilsSub.nullToBlank(outputVO.cookingExPublish) === '1') ? '1' : '';
    // 料理分類
    vo.cookingDiv = PlessViewUtilsSub.nullToBlank(outputVO.cookingDiv);
    // 料理名
    vo.cookingNameList = PlessViewUtilsSub.nullToBlank(outputVO.cookingName);
    // 材料名
    vo.materialNameList = PlessViewUtilsSub.nullToBlank(outputVO.materialName);
    // キーワード
    vo.keyWordList = PlessViewUtilsSub.nullToBlank(outputVO.keyWord);
    // 季節・催事
    vo.eventId = PlessViewUtilsSub.nullToBlank(outputVO.eventID);
    // 撮影場所区分
    vo.photoContentsDiv = PlessViewUtilsSub.nullToBlank(outputVO.photoContentsDiv);
    // 撮影場所ID
    vo.photoStudioId = PlessViewUtilsSub.nullToBlank(outputVO.photoStudioID);
    // 画像作成指示者
    vo.imageInstructUserId = PlessViewUtilsSub.nullToBlank(outputVO.imageInstructUser);
    // 作成指示日（ＦＲＯＭ）
    vo.imageInstructDateFrom = PlessViewUtilsSub.nullToBlank(outputVO.imageInstructDateStart);
    // 作成指示日（ＴＯ）
    vo.imageInstructDateTo = PlessViewUtilsSub.nullToBlank(outputVO.imageInstructDateEnd);
    // 画像ファイル登録日（ＦＲＯＭ）
    vo.fileRegistDateFrom = PlessViewUtilsSub.nullToBlank(outputVO.fileRegistDateStart);
    // 画像ファイル登録日（ＴＯ）
    vo.fileRegistDateTo = PlessViewUtilsSub.nullToBlank(outputVO.fileRegistDateEnd);
    // 画像ステータス
    vo.status = PlessViewUtilsSub.nullToBlank(outputVO.status);
    // 画像作成指示
    vo.imageInstruct = PlessViewUtilsSub.nullToBlank(outputVO.imageInstrucrDiv);
    // 使用停止フラグ
    vo.enabled = PlessViewUtilsSub.nullToBlank(outputVO.imageEnableDiv);
    // 撮影予定日(From)
    vo.photoScheduleFrom = PlessViewUtilsSub.nullToBlank(outputVO.photoScheduleStart);
    // 撮影予定日(To)
    vo.photoScheduleTo = PlessViewUtilsSub.nullToBlank(outputVO.photoScheduleEnd);
    // 部門コード
    vo.classCode = PlessViewUtilsSub.nullToBlank(outputVO.classCode);
    // 複数コード登録
    vo.multipleCode = outputVO.multipleCode;
    // 使用開始受注コード
    vo.startOrderCode = PlessViewUtilsSub.nullToBlank(outputVO.startOrderCode);
    // 使用開始配達企画回(翌週)
    vo.startDelivCatalogId = PlessViewUtilsSub.nullToBlank(outputVO.startDelivCatalogId);
    // 請求先名
    vo.billingName = PlessViewUtilsSub.nullToBlank(outputVO.billingName);
    // バイヤーコード
    vo.buyerCode = PlessViewUtilsSub.nullToBlank(outputVO.buyerCode);
    // 出力／未出力選択
    vo.outputFlg = PlessViewUtilsSub.nullToBlank(outputVO.outputFlg);
    // 繰越
    vo.carriedForward = outputVO.carriedForward;
    // C2PF対象
    vo.c2pfTarget = outputVO.c2pfTarget;
    // 変更前撮影予定日
    vo.photographingChangeSchedule = outputVO.photographingChangeSchedule;
    
    return vo;
  }

  /**
   * GetImageInfoVOを返却する
   *
   * @return GetImageInfoVO
   */
  public createGetImageInfoVO(inputVO: KYMW1600InputModel): GetImageInfoModel {
    const vo: GetImageInfoModel = new GetImageInfoModel();
    // Pコード
    vo.pcodeList = PlessViewUtilsSub.nullToBlank(inputVO.pcode);
    // 商品案内用商品名
    vo.guideGoodsName = '';
    // 商品案内用規格名
    vo.guideStandardName = '';
    // 画像名
    vo.imageName = '';
    // 画像ファイル名
    vo.imageFileName = '';
    // 画像所属
    vo.imageBelongId = '';
    // 画像種類
    vo.imageKind = '';
    // 画像種別
    vo.imageType = '';
    // 調理指示
    vo.processInstruct = '';
    // 備考
    vo.remarksList = '';
    // 調理例掲載区分
    vo.cookingExPublish = '';
    // 料理分類
    vo.cookingDiv = '';
    // 料理名
    vo.cookingNameList = '';
    // 材料名
    vo.materialNameList = '';
    // キーワード
    vo.keyWordList = '';
    // 季節・催事
    vo.eventId = '';
    // 撮影場所区分
    vo.photoContentsDiv = '';
    // 撮影場所ID
    vo.photoStudioId = '';
    // 画像作成指示者
    vo.imageInstructUserId = '';
    // 作成指示日（ＦＲＯＭ）
    vo.imageInstructDateFrom = '';
    // 作成指示日（ＴＯ）
    vo.imageInstructDateTo = '';
    // 画像ファイル登録日（ＦＲＯＭ）
    vo.fileRegistDateFrom = '';
    // 画像ファイル登録日（ＴＯ）
    vo.fileRegistDateTo = '';
    // 画像ステータス
    vo.status = '';
    // 画像作成指示
    vo.imageInstruct = '';
    // 使用停止フラグ
    vo.enabled = '';
    // 撮影予定日(From)
    vo.photoScheduleFrom = '';
    // 撮影予定日(To)
    vo.photoScheduleTo = '';
    // 部門コード
    vo.classCode = '';
    // 複数コード登録
    vo.multipleCode = false;
    // 使用開始受注コード
    vo.startOrderCode = '';
    // 使用開始配達企画回(翌週)
    vo.startDelivCatalogId = '';
    // 請求先名
    vo.billingName = '';
    // バイヤーコード
    vo.buyerCode = '';
    // 出力／未出力選択
    vo.outputFlg = '';
    // 繰越
    vo.carriedForward = false;
    // C2PF対象
    vo.c2pfTarget = false;
    // 変更前撮影予定日
    vo.photographingChangeSchedule = false;

    return vo;
  }

  /**
   * GetUseImageInfoVOを返却する
   *
   * @return GetUseImageInfoVO
   */
  public getUseImageInfoVO(outputVO: GetImageInfoModel): GetUseImageInfoModel {
    const vo: GetUseImageInfoModel = new GetUseImageInfoModel();
    // Pコード
    vo.pcodeList = PlessViewUtilsSub.nullToBlank(outputVO.pcodeList);
    // 商品案内用商品名
    vo.guideGoodsName = PlessViewUtilsSub.nullToBlank(outputVO.guideGoodsName);
    // 商品案内用規格名
    vo.guideStandardName = PlessViewUtilsSub.nullToBlank(outputVO.guideStandardName);
    // 画像名
    vo.imageName = PlessViewUtilsSub.nullToBlank(outputVO.imageName);
    // 画像ファイル名
    vo.imageFileName = PlessViewUtilsSub.nullToBlank(outputVO.imageFileName);
    // 画像所属
    vo.imageBelongId = PlessViewUtilsSub.nullToBlank(outputVO.imageBelongId);
    // 画像種類
    vo.imageKind = PlessViewUtilsSub.nullToBlank(outputVO.imageKind);
    // 画像種別
    vo.imageType = PlessViewUtilsSub.nullToBlank(outputVO.imageType);
    // 調理指示
    vo.processInstruct = PlessViewUtilsSub.nullToBlank(outputVO.processInstruct);
    // 備考
    vo.remarksList = PlessViewUtilsSub.nullToBlank(outputVO.remarksList);
    // 調理例掲載区分
    // 調理例掲載区分が掲載の場合
    vo.cookingExPublish = (PlessViewUtilsSub.nullToBlank(outputVO.cookingExPublish) === '1') ? '1' : '';
    // 料理分類
    vo.cookingDiv = PlessViewUtilsSub.nullToBlank(outputVO.cookingDiv);
    // 料理名
    vo.cookingNameList = PlessViewUtilsSub.nullToBlank(outputVO.cookingNameList);
    // 材料名
    vo.materialNameList = PlessViewUtilsSub.nullToBlank(outputVO.materialNameList);
    // キーワード
    vo.keyWordList = PlessViewUtilsSub.nullToBlank(outputVO.keyWordList);
    // 季節・催事
    vo.eventId = PlessViewUtilsSub.nullToBlank(outputVO.eventId);
    // 撮影場所区分
    vo.photoContentsDiv = PlessViewUtilsSub.nullToBlank(outputVO.photoContentsDiv);
    // 撮影場所ID
    vo.photoStudioId = PlessViewUtilsSub.nullToBlank(outputVO.photoStudioId);
    // 画像作成指示者
    vo.imageInstructUserId = PlessViewUtilsSub.nullToBlank(outputVO.imageInstructUserId);
    // 作成指示日（ＦＲＯＭ）
    vo.imageInstructDateFrom = PlessViewUtilsSub.nullToBlank(outputVO.imageInstructDateFrom);
    // 作成指示日（ＴＯ）
    vo.imageInstructDateTo = PlessViewUtilsSub.nullToBlank(outputVO.imageInstructDateTo);
    // 画像ファイル登録日（ＦＲＯＭ）
    vo.fileRegistDateFrom = PlessViewUtilsSub.nullToBlank(outputVO.fileRegistDateFrom);
    // 画像ファイル登録日（ＴＯ）
    vo.fileRegistDateTo = PlessViewUtilsSub.nullToBlank(outputVO.fileRegistDateTo);
    // 画像ステータス
    vo.status = PlessViewUtilsSub.nullToBlank(outputVO.status);
    // 画像作成指示
    vo.imageInstruct = PlessViewUtilsSub.nullToBlank(outputVO.imageInstruct);
    // 使用停止フラグ
    vo.enabled = PlessViewUtilsSub.nullToBlank(outputVO.enabled);
    // 受注コード
    vo.orderCode = this.viewHeler.vw_ImageInfoList.imageInfoListOrderCode;
    // 撮影予定日(From)
    vo.photoScheduleFrom = PlessViewUtilsSub.nullToBlank(outputVO.photoScheduleFrom);
    // 撮影予定日(To) 
    vo.photoScheduleTo = PlessViewUtilsSub.nullToBlank(outputVO.photoScheduleTo);
    // 部門コード
    vo.classCode = PlessViewUtilsSub.nullToBlank(outputVO.classCode);
    // 複数コード登録
    vo.multipleCode = outputVO.multipleCode;
    // 使用開始受注コード
    vo.startOrderCode = PlessViewUtilsSub.nullToBlank(outputVO.startOrderCode);
    // 使用開始配達企画回(翌週)
    vo.startDelivCatalogId = PlessViewUtilsSub.nullToBlank(outputVO.startDelivCatalogId);
    // 請求先名
    vo.billingName = PlessViewUtilsSub.nullToBlank(outputVO.billingName);
    // バイヤーコード
    vo.buyerCode = PlessViewUtilsSub.nullToBlank(outputVO.buyerCode);
    // 出力／未出力選択
    vo.outputFlg = PlessViewUtilsSub.nullToBlank(outputVO.outputFlg);
    // 繰越
    vo.carriedForward = outputVO.carriedForward;
    // C2PF対象
    vo.c2pfTarget = outputVO.c2pfTarget;
    // 変更前撮影予定日
    vo.photographingChangeSchedule = outputVO.photographingChangeSchedule;

    return vo;
  }

  /**
   * GetImageInfoDetailVOを返却する
   *
   * @return GetImageInfoDetailVO
   */
  public getGetImageInfoDetailVO(): any {
    const vo = {
      imageId: this.selectedImageId,
    };
    return vo;
  }

  /**
   * KYMW0E00InputVOを返却する
   *
   * @return KYMW0E00InputVO
   */
  public getKYMW0E00InputVO(processDiv: number): KYMW0E00InputModel {
    const vo: KYMW0E00InputModel = new KYMW0E00InputModel();
    vo.formID = 'KYMW1600';
    vo.processDiv = processDiv;
    vo.imageID = this.selectedImageId;
    vo.imageName = this.selectedImageName;
    vo.imageFileName = this.selectedImageFileName;
    vo.startOrderCodeBefore = this.startOrderCodeBefore;
    vo.endOrderCodeBefore = this.endOrderCodeBefore;
    vo.startOrderCodeAfter = this.imageInfoDetailBox.txi_StartOrderCode.selectedOrderCode;
    vo.endOrderCodeAfter = this.imageInfoDetailBox.txi_EndOrderCode1.selectedOrderCode;

    return vo;
  }

  /**
   * 選択されたイメージを再ロードする
   * @param serverData
   */
  public reloadSelectedGoodsImage(serverData): void {

    /** 一覧の画像 */
    if (this.imageInfoList instanceof Array) {
      for (let i = Number(0); i < this.imageInfoList.length; i++) {
        if (this.imageInfoList[i].ImageId === this.selectedImageId) {
          const image = document.getElementById(`img-${i}`);
          image.setAttribute("src", serverData.ImagePath);
        }
      }
    } else {
      const image = document.getElementById(`img-0`);
      image.setAttribute("src", serverData.ImagePath);
    }

    /**　情報詳細の画像 */
    const imageDetail = document.getElementById("img_GoodsImage");
    imageDetail.setAttribute("src", serverData.ImagePath);
  }

  /**
   * 停止、停止解除、削除処理後更新
   */
  public updateEnabledDelete(procType: string): void {
    // 一覧から削除
    if (procType === '3') {
      if (this.imageInfoList instanceof Array) {
        for (let i = Number(0); i < this.imageInfoList.length; i++) {
          if (this.imageInfoList[i].ImageId === this.selectedImageId) {
            this.imageInfoList.splice(i, 1);
          }
        }
        this.viewHeler.vw_ImageInfoList.imageInfoListCnt = String(this.imageInfoList.length);
      } else {
        this.imageInfoList = null;
        this.viewHeler.vw_ImageInfoList.imageInfoListCnt = '0';
      }
    }

    // 画像詳細情報削除
    this.goodsImage = '';
    this.imageInfoDetailBox.clear();
    this.imageDetailButtonEnable(false);
    this.selectedImageId = '';
    this.kymw1600Component.setImageBackColor();
  }

  /**
   * 選択されたイメージIndexを取得する
   */
  public getSelectedImageIndex(): number {
    if (this.imageInfoList instanceof Array) {
      for (let i = Number(0); i < this.imageInfoList.length; i++) {
        if (this.imageInfoList[i].ImageId === this.selectedImageId) {
          return i;
        }
      }
    }
    return 0;
  }

  /**
   * VIEW取得処理を行う
   */
  public get view(): KYMW1600Model {
    return this;
  }

  /**
   * VIEWHelper取得処理を行う
   */
  public get viewHeler(): KYMW1600Component {
    return this.view.kymw1600Component;
  }

  /**
   * 画像詳細情報VBOX取得
   */
  public get imageInfoDetailBox(): ImageInfoDetailBoxComponent {
    return this.viewHeler.vw_ImageInfoDetail.imageInfoDetailBox;
  }

  /**
   * 'コード：名称'の文字列を取得する
   */
  private getCodeValueName(code: string, name: string): string {
    if (!PlessViewUtilsSub.isEmpty(code) && !PlessViewUtilsSub.isEmpty(name)) {
      return code + ':' + name;
    } else {
      return code + name;
    }
  }
}
